var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.row.specification)?_c('el-input-number',{attrs:{"min":0,"label":"描述文字","size":"mini","controls-position":"right"},on:{"change":function($event){return _vm.changeSkuNumbs(_vm.value, _vm.row)}},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}):_c('span',[_vm._v("-")])
}
var staticRenderFns = []

export { render, staticRenderFns }